import { render, staticRenderFns } from "./MyForm.vue?vue&type=template&id=8b2a8554"
import script from "./MyForm.vue?vue&type=script&lang=js"
export * from "./MyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports